import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Leaf, Menu, X } from "lucide-react";
import { useState } from "react";

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const authed = user && typeof user === "object";

  return (
    <header className="border-b border-[var(--border-line)] bg-paper sticky top-0 z-40 backdrop-blur">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-link" className="flex items-center gap-2.5 group">
          <Leaf className="w-5 h-5 text-[var(--forest)]" strokeWidth={1.5} />
          <span className="font-serif text-2xl tracking-tight">Wild Vitality</span>
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-sm">
          <Link data-testid="nav-library-link" to="/library" className="btn-ghost">Library</Link>
          <Link data-testid="nav-foraging-link" to="/foraging" className="btn-ghost">Foraging Safety</Link>
          <Link data-testid="nav-about-link" to="/about" className="btn-ghost">About</Link>
          {authed ? (
            <>
              {user.role === "admin" && (
                <Link data-testid="nav-admin-link" to="/admin" className="btn-ghost">Admin</Link>
              )}
              <Link data-testid="nav-dashboard-link" to="/dashboard" className="btn-ghost">Account</Link>
              <button data-testid="nav-logout-btn" onClick={async () => { await logout(); nav("/"); }} className="btn-ghost">Sign out</button>
            </>
          ) : (
            <>
              <Link data-testid="nav-login-link" to="/login" className="btn-ghost">Sign in</Link>
              <Link data-testid="nav-unlock-cta" to="/unlock" className="btn-accent">Unlock for $4</Link>
            </>
          )}
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[var(--border-line)] px-6 py-4 flex flex-col gap-3 bg-paper">
          <Link onClick={() => setOpen(false)} to="/library" className="btn-ghost text-left">Library</Link>
          <Link onClick={() => setOpen(false)} to="/foraging" className="btn-ghost text-left">Foraging Safety</Link>
          <Link onClick={() => setOpen(false)} to="/about" className="btn-ghost text-left">About</Link>
          {authed ? (
            <>
              {user.role === "admin" && <Link onClick={() => setOpen(false)} to="/admin" className="btn-ghost text-left">Admin</Link>}
              <Link onClick={() => setOpen(false)} to="/dashboard" className="btn-ghost text-left">Account</Link>
              <button onClick={async () => { setOpen(false); await logout(); nav("/"); }} className="btn-ghost text-left">Sign out</button>
            </>
          ) : (
            <>
              <Link onClick={() => setOpen(false)} to="/login" className="btn-ghost text-left">Sign in</Link>
              <Link onClick={() => setOpen(false)} to="/unlock" className="btn-accent w-fit">Unlock for $4</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
